module.exports = __webpack_public_path__ + "img/sw-b04.b69f95a7.png";